(function (window, undefined) {
    "use strict";
    /*
     * The MIT License
     *
     * Copyright (c) 2015, Sebastian Sdorra
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE.
     */

    angular
      .module("adf.widget.plm", ["adf.provider", "chart.js"])
      .config(RegisterWidgets);

    function RegisterWidgets(dashboardProvider) {
        var widget = {
            reload: true,
            category: "Dashboard",
            controllerAs: "vm"
        };

        var getEventLog = angular.extend({
            resolve: {
                /* @ngInject */
                tabledata: ["DashboardFactory", "config", function (DashboardFactory, config) {
                    return DashboardFactory.getEventLog();
                }]
            }
        }, widget);

        var getSpecLock = angular.extend({
            resolve: {
                /* @ngInject */
                tabledata: ["DashboardFactory", "config", function (DashboardFactory, config) {
                    return DashboardFactory.getSpecLock();
                }]
            }
        }, widget);

        var getBuyReady = angular.extend({
            resolve: {
                /* @ngInject */
                tabledata: ["DashboardFactory", "config", function (DashboardFactory, config) {
                    return DashboardFactory.getBuyReady();
                }]
            }
        }, widget);

        var getCostingComplete = angular.extend({
            resolve: {
                /* @ngInject */
                tabledata: ["DashboardFactory", "config", function (DashboardFactory, config) {
                    return DashboardFactory.getCostingComplete();
                }]
            }
        }, widget);

        var getPrototypeStatuses = angular.extend({
            resolve: {
                /* @ngInject */
                tabledata: ["DashboardFactory", "config", function (DashboardFactory, config) {
                    return DashboardFactory.getPrototypeStatuses();
                }]
            }
        }, widget);

        var getLastViewedProjects = angular.extend({
            resolve: {
                /* @ngInject */
                tabledata: ["DashboardFactory", "config", function (DashboardFactory, config) {
                    return DashboardFactory.getLastViewedProjects();
                }]
            }
        }, widget);

        var getPatternStatuses = angular.extend({
            resolve: {
                /* @ngInject */
                tabledata: ["DashboardFactory", "config", function (DashboardFactory, config) {
                    return DashboardFactory.getPatternStatuses();
                }]
            }
        }, widget);

        var getBriefStatuses = angular.extend({
            resolve: {
                /* @ngInject */
                tabledata: ["DashboardFactory", "config", function (DashboardFactory, config) {
                    return DashboardFactory.getBriefStatuses();
                }]
            }
        }, widget);

        //Note that there is a function in KPIDashboard.js (filterWidgets) that determines which widgets are available at runtime.
        //You have to register your widget here, then make it available by modifying the API. See PLM.WebAPI.Controllers.DashboardController.cs
        dashboardProvider
            .widget("lastViewedProjects", angular.extend({
                title: "Last Viewed Projects",
                description: "Display the user's most recently viewed projects",
                controller: "DashboardController",
                templateUrl: "app/widgets/adf-widget-dashboard/dist/table.html?v=" + window.plmVersion.versionId,
                order: 1
            }, getLastViewedProjects))
            .widget("eventLog", angular.extend({
                title: "Project Events",
                description: "Display event log data in a table format",
                controller: "DashboardController",
                templateUrl: "app/widgets/adf-widget-dashboard/dist/table.html?v=" + window.plmVersion.versionId,
                order: 2
            }, getEventLog))
            .widget("briefStatuses", angular.extend({
                title: "Brief Statuses",
                description: "Display statuses for briefs in a pie chart",
                controller: "DashboardController",
                templateUrl: "app/widgets/adf-widget-dashboard/dist/table.html?v=" + window.plmVersion.versionId,
                order: 3
            }, getBriefStatuses))
            .widget("specLock", angular.extend({
                title: "Spec Lock",
                description: "Display spec lock data in a pie chart",
                controller: "DashboardController",
                templateUrl: "app/widgets/adf-widget-dashboard/dist/table.html?v=" + window.plmVersion.versionId,
                order: 4
            }, getSpecLock))
            .widget("patternStatuses", angular.extend({
                title: "Pattern Statuses",
                description: "Display statuses for pattern projects in a pie chart",
                controller: "DashboardController",
                templateUrl: "app/widgets/adf-widget-dashboard/dist/table.html?v=" + window.plmVersion.versionId,
                order: 5
            }, getPatternStatuses))
            .widget("buyReady", angular.extend({
                title: "Buy Ready",
                description: "Display buy ready project data in a pie chart",
                controller: "DashboardController",
                templateUrl: "app/widgets/adf-widget-dashboard/dist/table.html?v=" + window.plmVersion.versionId,
                order: 6
            }, getBuyReady))
            .widget("prototypeStatuses", angular.extend({
                title: "Prototype Statuses",
                description: "Display statuses for prototype projects in a pie chart",
                controller: "DashboardController",
                templateUrl: "app/widgets/adf-widget-dashboard/dist/table.html?v=" + window.plmVersion.versionId,
                order: 7
            }, getPrototypeStatuses))
            .widget("costingComplete", angular.extend({
                title: "Costing Complete",
                description: "Display costing complete data in a bar chart",
                controller: "DashboardController",
                templateUrl: "app/widgets/adf-widget-dashboard/dist/table.html",
                order: 8
            }, getCostingComplete));
    }
    RegisterWidgets.$inject = ["dashboardProvider"];

    angular
      .module("adf.widget.plm")
      .factory("DashboardFactory", DashboardFactory);

    function DashboardFactory() {
        var service = {
            getEventLog: getEventLog,
            getPrototypeStatuses: getPrototypeStatuses,
            getPatternStatuses: getPatternStatuses,
            getBriefStatuses: getBriefStatuses,
            getLastViewedProjects: getLastViewedProjects,
            getSpecLock: getSpecLock,
            getCostingComplete: getCostingComplete,
            getBuyReady: getBuyReady
        };

        return service;

        function getEventLog() {
            return [{ "element": "eventLog" }];
        };

        function getSpecLock() {
            return [{ "element": "specLock" }];
        };

        function getBuyReady() {
            return [{ "element": "buyReady" }];
        };

        function getCostingComplete() {
            return [{ "element": "costingComplete" }];
        };

        function getPrototypeStatuses() {
            return [{ "element": "prototypeStatuses" }];
        };

        function getLastViewedProjects() {
            return [{ "element": "lastViewedProjects" }];
        };

        function getPatternStatuses() {
            return [{ "element": "patternStatuses" }];
        };

        function getBriefStatuses() {
            return [{ "element": "briefStatuses" }];
        };
    }
    DashboardFactory.$inject = ["$q", "$http", "WebAPIUrl"];


    angular
      .module("adf.widget.plm")
      .controller("DashboardController", DashboardController);

    function DashboardController($rootScope, $filter, config, tabledata, timeConvert) {
        var vm = this;

        if (tabledata) {
            vm.tableData = tabledata;
        }

        //for use in templates
        vm.timeConvert = timeConvert;
    }
    DashboardController.$inject = ["$rootScope", "$filter", "config", "tabledata", "timeConvert"];

})(window);
